var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 12.5V15.1667",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66677 25.8327H25.3334C26.2168 25.8265 27.0398 25.3832 27.531 24.649C28.0223 23.9148 28.1181 22.985 27.7868 22.166L18.3201 5.8327C17.8504 4.98386 16.9569 4.45703 15.9868 4.45703C15.0167 4.45703 14.1231 4.98386 13.6534 5.8327L4.18677 22.166C3.86196 22.9657 3.94426 23.8731 4.40763 24.6012C4.87101 25.3294 5.65815 25.7883 6.5201 25.8327",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 19.8346H16.0134",
    stroke: "#EA4335",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.66342b047f960e0102070f075adc7005.svg";
export { ForwardRef as ReactComponent };